<template>
  <v-content>
    <v-dialog
      v-model="show"
      max-width="780"
      :fullscreen="$vuetify.breakpoint.xs"
      scrollable>
      <v-card>
        <v-card-title class="primary--text fixNotchPaddingTop">
          {{ this.windowTitle }}          
					<v-spacer></v-spacer>					
          <v-btn icon @click="show=false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="mt-2 pb-0">
          <v-form ref="form" autocomplete="off">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  label="Fecha registro"
                  v-model="creationDate"
                  disabled/>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label=" Clave validación"
                  v-model="validationKey"
                  disabled/>
              </v-col>
              <v-col cols="6">								
								<v-dialog
									ref="dialog1"
									v-model="modal1"
									:return-value.sync="dateStart"
									persistent
									width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="dateStartFormatted"
                      :rules="[validationRules.required]"
											label="Fecha inicio validez"
                      :readonly="readonly"
											:disabled="isLoading"
											v-bind="attrs"
											v-on="on"
                      @blur="dateStart = parseDate(dateStartFormatted)"/>
									</template>
                <v-date-picker 
                  v-if="modal1"
									v-model="dateStart"
									color="primary"
                  scrollable>
									<v-spacer></v-spacer>
									<v-btn color="primary" text style="width: 100px;" @click="$refs.dialog1.save(dateStart)">Aceptar</v-btn>
									<v-btn color="black" text style="width: 100px;" @click="modal1=false">Cancelar</v-btn>  
								</v-date-picker>
							</v-dialog>
              </v-col>
              <v-col cols="6">								
								<v-dialog
									ref="dialog2"
									v-model="modal2"
									:return-value.sync="dateFinish"
									persistent
									width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="dateFinishFormatted"
                      :rules="[validationRules.required, validateNotBeforeDate(dateStartFormatted, dateFinishFormatted)]"
											label="Fecha fin validez"
                      :readonly="readonly"
											:disabled="isLoading"
											v-bind="attrs"
											v-on="on"
                      @blur="dateFinish = parseDate(dateFinishFormatted)"/>
									</template>
                <v-date-picker 
                  v-if="modal2"
									v-model="dateFinish"
									color="primary"
                  scrollable>
									<v-spacer></v-spacer>
									<v-btn color="primary" text style="width: 100px;" @click="$refs.dialog2.save(dateFinish)">Aceptar</v-btn>
									<v-btn color="black" text style="width: 100px;" @click="modal2=false">Cancelar</v-btn>  
								</v-date-picker>
							</v-dialog>
              </v-col>              
              <v-col cols="12">
                <v-text-field
                  label="Título"
                  v-model="title"
                  :rules="[validationRules.required]"
                  :disabled="isLoading"
                  counter
                  maxlength="250"/>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Observaciones"
                  v-model="notes"
                  :disabled="isLoading"
                  counter
                  maxlength="255"/>
              </v-col>
              <v-col cols="12">
              <v-col cols="6">
                <span>{{"Habilitado"}}</span>
                <v-radio-group
                  v-model="enabled"
                  :disabled="isLoading"
                  style="position: relative; top: -15px; max-height: 94px"
                  row
                >
                  <v-radio label="Sí" :value="true" />
                  <v-radio label="No" :value="false" />
                </v-radio-group>
              </v-col>
                <v-col cols="12">
									<v-row>
										<v-col cols="1">
											<v-icon 
												color="green" 
												v-if="file"
												style="margin-top: 15px; cursor: none; float: right;">
												mdi-check-bold
											</v-icon>
										</v-col>
										<v-col cols="10">
											<v-file-input
												v-model="file" ref="file"
												label="Seleccionar archivo"
												hint="(Tamaño máximo de archivo: 5MB - Formato de archivo: PDF)"
												truncate-length="50"
												:loading="loading"
												:disabled="loading || file"
												:rules="[validationRules.required]"
												prepend-icon="mdi-paperclip"
												persistent-hint
												accept=".pdf"
												show-size
												@change="uploadDocument()"/>
										</v-col>
										<v-col cols="1">
											<v-icon 
												v-if="file && !isNew" 
												:disabled="isLoading" 
												class="file-download" 
												@click="downloadDocument()">
												mdi-download
											</v-icon>
										</v-col>
									</v-row>
								</v-col>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            v-if="showDelete"
            class="justify-start"
            color="red"
            text
            :disabled="isLoading"
            @click="deleteItem()"
          >
             <v-icon
            left
            dark
            >
            mdi-delete
            </v-icon>Eliminar</v-btn>
          
          <v-spacer></v-spacer>
          <v-btn 
						text 
						color="primary"
            :disabled="isLoading"
						@click="save()">
						Guardar
					</v-btn>
          <v-btn
						text 
						color="black" 
            :disabled="isLoading"
						@click="close()">
						Cerrar
					</v-btn>
        </v-card-actions>
      </v-card>

      <v-snackbar
        style="z-index: 100002"
        v-model="showToast"
        :timeout="timeout"
        color="green"
      >
        {{ toastText }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="showToast = false">Cerrar</v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
    <ConfirmDialog
      ref="confirmDialog"
      title="Borrar documento"
      message="Esta acción no puede deshacerse. ¿Desea continuar?"
      titleOk="Eliminar"
      titleCancel="Cerrar"
      @confirmed="deleteDocument($event)"
    />
  </v-content>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import api from "../../../api/icoev";
import ConfirmDialog from "../../common/ConfirmDialog";
import BaseModule from "../../common/BaseModule";

export default {
  name: "DocumentDialog",
  mixins: [BaseModule],
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      showDelete: false,
      loading: false,
      isLoading: false,
      show: false,
			isNew: false,
      windowTitle: null,
			readonly: true,
			//
			id: null,
			creationDate: null,
			validationKey: null,
			internalCode: null,
			validityStartDate: null,
			validityFinishDate: null,            
			dateStartFormatted: null,
			dateFinishFormatted: null,
			author: null,
			title: null,
			notes: null,
			enabled: true,
			fileName: null,
			fileSize: null,
			//     
      showToast: false,
      toastText: null,
      timeout: 2000,
      isDirty: false,
      document: null,
      dateStart: null,
      dateFinish: null,
      modal1: false,
      modal2: false,
      file: null,
			msgCb: null,
    };
  },
  methods: {
		validateNotBeforeDate (before, value) {
			value = this.fixIEDate(value);
			var beforeDate = this.parseLocalDate(before);

			if (value === undefined || value == null || value.length != 10) {
				return false;
			}

			var esValido = this.parseLocalDate(value);
			if (esValido.getTime() !== esValido.getTime())
					return false;

			return (esValido.getTime() >= beforeDate.getTime()) || 'La fecha no puede ser anterior a ' + before;
		},
    // eslint-disable-next-line no-unused-vars
    deleteDocument: function (item) {
      this.isLoading = true;

      api.deleteDocument(this.id,
        (data) => {
          this.isLoading = false;

          this.$log.info(data);

					if (!data) {
						this.$log.error("Se produjo un error al tratar de borrar el documento! [ id: {0} ]", item.id);
						return;
					}
      
					this.show = false;          

					if (this.msgCb) {
            this.msgCb();
					}
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = error;
          this.$log.error(error);
        }
      );
    },
    deleteItem() {
			this.$refs.confirmDialog.confirm(this.document);
    },
    showDialog(item, isNew, msgCb) {
			if (this.$refs.form != null) {
				this.$refs.form.resetValidation();
			}

      this.document = item;
			this.id = item.id;
			this.creationDate = this.formatLocalDateTime(item.creationDate);
			this.validationKey = item.validationKey;
			this.internalCode = item.internalCode;
			this.dateStart = item.validityStartDate.substr(0, 10);
			this.dateFinish = item.validityFinishDate.substr(0, 10);
			this.dateStartFormatted = this.formatDate(this.dateStart);
			this.dateFinishFormatted = this.formatDate(this.dateFinish);
			this.author = item.author;
			this.title = item.title;
			this.notes = item.notes;
			this.enabled = item.enabled;
			this.fileName = item.fileName;
			this.fileSize = item.fileSize;

			if (this.fileName) {
				this.file = {
					name: this.fileName,
					size: this.fileSize
				};
			} else {
				this.file = null;
			}

      this.windowTitle = isNew ? 'Crear documento' : 'Editar documento';
			this.showDelete = !isNew;
			this.isDirty = false;
			this.msgCb = msgCb;
			this.isNew = isNew;
      this.show = true;
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      
			var data = {
        id: this.document.id,
        creationDate: this.document.creationDate,
        validationKey: this.document.validationKey,
        internalCode: this.document.internalCode,
        validityStartDate: this.parseLocalDate(new Date(this.dateStart).getTime()),
        validityFinishDate: this.parseLocalDate(new Date(this.dateFinish).getTime()),
        author: this.document.author,                     
        title: this.title,
        notes: this.notes, 
        enabled: this.enabled,                                                             
      };

      this.isLoading = true;

      api.editDocument(data,
        () => {
          this.isLoading = false;
          this.show = false;

					if (this.msgCb) {
            this.msgCb();
					}
        },
        (err) => {
          alert(err);
        }
      );
    },
		close() {
      this.show = false;

			if (this.isNew) {
				this.deleteDocument(this.id);
				return;
			}

			if (this.isDirty && this.msgCb) {
				this.msgCb();
			}
		},
		downloadDocument() {
      this.isLoading = true;

      api.downloadDocument(this.id, 
				() => { 
					this.isLoading = false; 
				}, 
				() => { 
					this.isLoading = false; 
				});
    },
    uploadDocument() {
      this.isLoading = true;

      let me = this;            
      let formData = new FormData();
      formData.append('documentId', this.id);
			formData.append('file', this.file ? this.file : null);
      formData.append('fileName', this.file ? this.file.name : '');
      formData.append('fileSize', this.file ? this.file.size : '');
      formData.append('fileType', this.file ? this.file.type : '');
            
			api.uploadDocument(formData,
        () => {
          me.isLoading = false;
					me.isDirty = true;
				},
				(error) => {
					me.isLoading = false;					
					me.$refs.file.errorMessages = "Se ha producido un error al subir el documento";
					console.log(error);
					me.file = null;
				});
      },
			formatDate (date) {
				if (!date) return null

				const [year, month, day] = date.split('-')
				return `${day}/${month}/${year}`
			},
			parseDate (date) {
				if (!date) return null

				const [day, month, year] = date.split('/')
				return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
			},
  },
	watch: {
		dateStart () {
				this.dateStartFormatted = this.formatDate(this.dateStart);
		},
		dateFinish () {
				this.dateFinishFormatted = this.formatDate(this.dateFinish);
		},
	},
};
</script>


<style scoped>
.file-download {
  margin-top: 17px;
  color: #065535 ;
  cursor: pointer;
}
</style>